import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class CrowdStrike extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M22.816,17.709a4.246,4.246,0,0,0-2.582.4,3.365,3.365,0,0,1-2.161.544c.166.3.5.718,1.555.792s1.559.107,1,1.421c.013-.4-.08-1.164-1.127-1.03s-1.291,1.077-.168,1.548c-.365.073-1.139.117-1.692-1.329a1.681,1.681,0,0,1-2.043-.327,3.038,3.038,0,0,0,.834.144A6.966,6.966,0,0,1,14,17.776a3.408,3.408,0,0,0,1.484.75,38.07,38.07,0,0,0-3.734-3.748c1.106.722,2.441,1.863,4.624,1.607s3.652-.757,6.445,1.324" />
        <path d="M13.468,17.194a16.562,16.562,0,0,0-3.423-1.16A8.652,8.652,0,0,1,5.394,13.2c.817.6,2.483,1.8,4.2,1.671A3.565,3.565,0,0,0,8.276,13.9c.649.155,2.607.656,5.192,3.3" />
        <path d="M10.487,12.125c-.353-1.013-.99-2.309-4.012-4.236A28.505,28.505,0,0,1,0,2.589c.2.838,1.1,3.017,5.63,5.847,1.488,1.015,3.408,1.641,4.857,3.689" />
        <path d="M10.674,13.594c-.372-.858-1.119-1.958-4.046-3.528A21.6,21.6,0,0,1,.9,5.936c.188.8,1.15,2.552,5.292,4.742,1.147.632,3.086,1.224,4.482,2.916" />
        <path d="M21.746,15.855c1.081.164,1.027.393,1.038.789a3.982,3.982,0,0,0-1.038-.789M13.512,9.162C7.807,7.53,5.539,5.47,3.784,3.313,4.585,5.8,6.5,6.684,8.538,8.35A9.01,9.01,0,0,1,11.3,11.9c1.34,2.194,1.553,2.556,2.883,3.514,1.567,1.04,3.463.336,5.542.662A6.979,6.979,0,0,1,23.9,18.594c.436-.778-.606-1.9-.887-2.18.15-1.018-2.258-1.466-3.17-1.814-.18-.069-.623-.171-.238-1.085.518-1.262,1.058-2.36-6.088-4.353" />
      </svg>
    );
  }
}

export default CrowdStrike;
